<template>
  <div class="d-flex">
    <ci-awesome-icon class="ml-2" v-for="action in actions" :key="`${_uid}-${action.type}`" :icon="action.icon" ratio="0.75" button @click="onActionClick(action)"  />
  </div>
</template>

<script>
import AwesomeIcon from '@/components/AwesomeIcon.vue';

export default {
  name: 'ItemActions',

  components: {
    'ci-awesome-icon': AwesomeIcon,
  },

  props: {
    actions: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },

  methods: {
    onActionClick(action) {
      this.$emit('click', action.type);
    },
  },
};
</script>
